import React from "react";
import PlayVideoPNG from "../../../assets/icons/play-video.png";

export const PlayVideoIcon: React.FC = () => {
  return <img src={PlayVideoPNG} alt="" className="w-[22px] h-[22px] cursor-pointer" />;
};
